<template>
  <v-dialog persistent v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">例外納入指示</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="exceptionApply()"
          :disabled="
            !valid ||
              '例外納入指示申請' === shipment.displayStatus ||
              '事前例外納入指示申請' === shipment.displayStatus
          "
          v-if="!isAcceptor"
          class="btn-search"
          >例外指示申請</v-btn
        >
        <v-btn
          :disabled="
            '例外納入指示申請' !== shipment.displayStatus &&
              '事前例外納入指示申請' !== shipment.displayStatus
          "
          @click="exceptionApplyCancel()"
          v-if="!isAcceptor"
          class="btn-search"
          >例外指示取消</v-btn
        >
        <v-btn
          @click="exceptionApplyConfirm()"
          v-if="isAcceptor"
          class="btn-search"
          >承認</v-btn
        >
        <v-btn
          @click="exceptionApplyReject()"
          v-if="isAcceptor"
          class="btn-search"
          >拒否</v-btn
        >

        <v-btn @click="show = false">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form ref="form" v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                clearable
                label="申請ステータス"
                :disabled="true"
                v-model="shipment.displayStatus"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <remote-autocomplete
                v-if="!isAcceptor"
                :disabled="isAcceptor"
                :rules="[(v) => !!v || `希望納入場所 can not be null`]"
                label="希望納入場所"
                @change="availDaysChange()"
                url="warehouses/reservable-kv"
                v-model="shipment.finallyWarehouseId"
              ></remote-autocomplete>
              <remote-autocomplete
                v-if="isAcceptor"
                :disabled="isAcceptor"
                :rules="[(v) => !!v || `希望納入場所 can not be null`]"
                label="希望納入場所"
                url="warehouses/kv"
                v-model="shipment.finallyWarehouseId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs12>
              <date-picker
                :disabled="isAcceptor || !shipment.finallyWarehouseId"
                :rules="[(v) => !!v || `希望納入予定日 can not be null`]"
                label="希望納入予定日"
                :min="today"
                :allowed-dates="allowedDates"
                v-model="shipment.forecastDeliveryDate"
              ></date-picker>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :disabled="isAcceptor"
                :rules="[
                  (v) =>
                    /^(((0|1)\d)|(2[0-3]))[0-5][0-9]$/.test(v) ||
                    `4桁の数の有効時間を入力してください`,
                ]"
                label="希望納入時間"
                v-model="shipment.forecastDeliveryTime"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                clearable
                :rules="[(v) => !!v || `コメント can not be null`]"
                label="コメント"
                v-model="shipment.remark"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      valid: false,
      query: {},
      user: {},
      id: null,
      shipment: {},
      today: null,
      availableDays: [],
      errors: {
        NO_CONFIG: '当該納入場所を指定できません。',
        NO_WAREHOUSE_MANAGER: this.$t('B0800.messages.noWhsManager'),
        DIFFERENT_BU:
          '事業本部が一致していないので、当該データを操作できません。',
        DIFFERENT_BUSINESS_UNIT:
          '操作者が属するBU以外のデータを操作するのは許可されません。',
        NOT_APPLY_STATUS:
          '例外納入指示申請以外のデータに対して承認/拒否を操作できません。',
      },
    }
  },
  methods: {
    availDaysChange() {
      this.getUsableDays()
    },
    param() {
      return {
        reserveDate: this.shipment.forecastDeliveryDate,
        reserveTime: this.formatedTime(this.shipment.forecastDeliveryTime),
        remark: this.shipment.remark,
        warehouseId: this.shipment.finallyWarehouseId,
      }
    },
    formatedTime(forecastDeliveryTime) {
      if (forecastDeliveryTime) {
        var time = this.$insert(forecastDeliveryTime, 0, 2, ':')
        time = this.$insert(time, 0, 5, ':')
        time = time + '00'
        return time
      }
      return null
    },
    getEmployee() {
      this.$http.get(`/employees/current`).then((res) => {
        this.user = res.data
        if (!this.isAcceptor) {
          this.shipment.forecastDeliveryDate = null
          this.shipment.forecastDeliveryTime = null
        }
      })
    },
    getUsableDays() {
      this.$http
        .get(
          `/warehouse-container-settings/shipment/${
            this.shipment.shipmentId
          }/warehouse/${this.shipment.finallyWarehouseId}/available-days`
        )
        .then((res) => {
          this.availableDays = res.data
        })
    },
    isAdmin() {
      return this.$isAdmin()
    },
    popup(shipment, today) {
      var forecastDeliveryTime = shipment.forecastDeliveryTime
      this.shipment = {
        ...shipment,
      }
      this.shipment.forecastDeliveryTime =
        forecastDeliveryTime &&
        [
          forecastDeliveryTime.slice(0, 2),
          forecastDeliveryTime.slice(3, 5),
        ].join('')
      this.today = today
      this.show = true
      this.getEmployee()
    },
    allowedDates(val) {
      return this.availableDays.indexOf(val) === -1
    },
    exceptionApply() {
      this.$http
        .put(
          `warehouse-container-settings/exception-apply/${
            this.shipment.shipmentId
          }`,
          this.param()
        )
        .then((res) => {
          if (res.data.success) {
            this.refreshData()
            this.$message('', '例外納入指示申請されました。')
          } else {
            this.$message('', res.data.localeMessage)
          }
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    exceptionApplyCancel() {
      this.$http
        .put(
          `warehouse-container-settings/exception-apply/${
            this.shipment.shipmentId
          }/cancel`,
          this.param()
        )
        .then((res) => {
          if (res.data.success) {
            this.refreshData()
            this.$message('', '例外納入指示申請が取消されました。')
          } else {
            this.$message('', res.data.localeMessage)
          }
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    exceptionApplyConfirm() {
      this.$http
        .put(
          `warehouse-container-settings/exception-apply/${
            this.shipment.shipmentId
          }/confirm`,
          this.param()
        )
        .then(() => {
          this.send(id)
          // this.refreshData()
          // this.$message('', '例外納入指示申請が承認されました。')
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    exceptionApplyReject() {
      this.$http
        .put(
          `warehouse-container-settings/exception-apply/${
            this.shipment.shipmentId
          }/reject`,
          this.param()
        )
        .then((res) => {
          if (res.data.success) {
            this.refreshData()
            this.$message('', '例外納入指示申請が拒否されました。')
          } else {
            this.$message('', res.data.localeMessage)
          }
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    refreshData() {
      this.show = false
      this.shipment = {}
      this.$emit('load')
    },
    send(id) {
      return this.$http
        .put(`/delivery-orders/${id}/send-email-date`)
        .then(() => {
          this.$message('', '納入指示済')
          this.$router.go(-1)
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
  },
  computed: {
    isAcceptor() {
      var acceptor = 'ROLE_SJL_ACCEPTOR'
      var importSales = 'ROLE_SJL_IMPORT_SALES'
      var importPromote = 'ROLE_SJL_IMPORT_PROMOTE'
      return (
        this.user &&
        this.user.roles &&
        (this.user.roles.includes(acceptor) ||
          this.user.roles.includes(importSales) ||
          this.user.roles.includes(importPromote))
      )
    },
    isSjl() {
      return this.user.companyName === 'SJL'
    },
  },
  watch: {},
}
</script>

<style></style>
